var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: #fc4500;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25,50A25,25,0,1,1,50,25,25.028,25.028,0,0,1,25,50ZM25,3.571A21.429,21.429,0,1,0,46.429,25,21.453,21.453,0,0,0,25,3.571Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M166.046,167.843a1.789,1.789,0,0,1-1.27-.526l-17.963-17.963a1.8,1.8,0,1,1,2.54-2.54l17.963,17.963a1.8,1.8,0,0,1-1.27,3.066Zm0,0",
    transform: "translate(-132.064 -132.066)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M148.082,167.842a1.8,1.8,0,0,1-1.27-3.066l17.963-17.963a1.8,1.8,0,0,1,2.54,2.54l-17.963,17.963A1.789,1.789,0,0,1,148.082,167.842Zm0,0",
    transform: "translate(-132.063 -132.064)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.1aca9689686dad5e620aac1ff81f267f.svg";
export { ForwardRef as ReactComponent };